<script setup lang="ts">
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { computed } from 'vue';
import VStyledHtml from '../VStyledHtml/VStyledHtml.vue';

interface Props {
  markdown: string;
}

const props = defineProps<Props>();

const html = computed(() =>
  DOMPurify.sanitize(
    marked.parse(props.markdown, {
      async: false,
      gfm: true,
    }),
  ),
);
</script>

<template>
  <!-- De HTML is hierboven al met DOMPurify gesanitized. -->
  <!-- eslint-disable vue/no-v-text-v-html-on-component -->
  <VStyledHtml v-html="html" />
  <!-- eslint-enable vue/no-v-text-v-html-on-component -->
</template>
